var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.5C10.3325 4.5 11 3.825 11 3C11 2.715 10.925 2.4525 10.7825 2.2275L9.5 0L8.2175 2.2275C8.075 2.4525 8 2.715 8 3C8 3.825 8.675 4.5 9.5 4.5ZM12.95 11.9925L12.1475 11.19L11.3375 11.9925C10.3625 12.9675 8.6525 12.975 7.67 11.9925L6.8675 11.19L6.05 11.9925C5.5625 12.48 4.91 12.75 4.22 12.75C3.6725 12.75 3.17 12.5775 2.75 12.2925V15.75C2.75 16.1625 3.0875 16.5 3.5 16.5H15.5C15.9125 16.5 16.25 16.1625 16.25 15.75V12.2925C15.83 12.5775 15.3275 12.75 14.78 12.75C14.09 12.75 13.4375 12.48 12.95 11.9925ZM14 6.75H10.25V5.25H8.75V6.75H5C3.755 6.75 2.75 7.755 2.75 9V10.155C2.75 10.965 3.41 11.625 4.22 11.625C4.61 11.625 4.985 11.475 5.255 11.1975L6.86 9.6L8.4575 11.1975C9.0125 11.7525 9.98 11.7525 10.535 11.1975L12.14 9.6L13.7375 11.1975C14.015 11.475 14.3825 11.625 14.7725 11.625C15.5825 11.625 16.2425 10.965 16.2425 10.155V9C16.25 7.755 15.245 6.75 14 6.75Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.05f164841fc911729909f2ad151d0229.svg";
export { ForwardRef as ReactComponent };